import { Link } from "react-router-dom";

const localities = [
  { label: "Sion", path: "/sion" },
  { label: "Sierre", path: "/sierre" },
  { label: "Martigny", path: "/martigny" },
  { label: "Grône", path: "/grone" },
  { label: "Crans-Montana", path: "/crans-montana" },
  { label: "Verbier", path: "/verbier" },
  { label: "Nendaz", path: "/nendaz" },
  { label: "Vercorin", path: "/vercorin" },
  { label: "Nax", path: "/nax" },
];

const services = [
  { label: "Pose de carrelage", path: "/services" },
  { label: "Rénovation salle de bain", path: "/services" },
  { label: "Douche italienne", path: "/services" },
  { label: "Faïence & mosaïque", path: "/services" },
  { label: "Carrelage extérieur", path: "/services" },
];

const navLinks = [
  { label: "Accueil", path: "/" },
  { label: "Services", path: "/services" },
  { label: "Contact", path: "/contact" },
  { label: "Politique de confidentialité", path: "/privacy" },
  { label: "Plan du site", path: "/sitemap" },
];

export default function Footer() {
  return (
    <footer className="bg-stone-900 text-stone-300">
      <div className="max-w-7xl mx-auto px-6 pt-16 pb-8">
        {/* 5 colonnes égales */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-8 lg:gap-6 mb-12">
          {/* Col 1 — Brand */}
          <div>
            <img
              src="/images/logo.png"
              alt="Logo Carreaux-Bat"
              className="h-12 w-auto object-contain mb-4 brightness-0 invert"
            />
            <p className="text-sm leading-relaxed text-stone-400 mb-5">
              Spécialiste du carrelage et de la rénovation de salles de bain en Valais. Plus de 20 ans d&apos;expérience au service de la qualité.
            </p>
            <div className="flex items-center gap-3 mb-5">
              <a href="https://www.facebook.com/profile.php?id=100078545047797" rel="nofollow" target="_blank" className="w-8 h-8 flex items-center justify-center rounded-full bg-stone-700 hover:bg-amber-700 transition-colors cursor-pointer">
                <i className="ri-facebook-fill text-sm"></i>
              </a>
            </div>
            <Link
              to="/contact"
              className="inline-flex items-center gap-2 px-5 py-2.5 bg-amber-700 text-white text-sm font-medium rounded-full hover:bg-amber-800 transition-colors whitespace-nowrap"
            >
              Devis gratuit
              <i className="ri-arrow-right-line"></i>
            </Link>
          </div>

          {/* Col 2 — Navigation */}
          <div>
            <h3 className="text-xs uppercase tracking-widest text-stone-400 mb-4">Navigation</h3>
            <ul className="space-y-2">
              {navLinks.map((link) => (
                <li key={link.path + link.label}>
                  <Link to={link.path} className="text-sm text-stone-300 hover:text-amber-400 transition-colors flex items-center gap-2">
                    <i className="ri-arrow-right-s-line text-amber-600"></i>
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Col 3 — Services */}
          <div>
            <h3 className="text-xs uppercase tracking-widest text-stone-400 mb-4">Services</h3>
            <ul className="space-y-2">
              {services.map((s) => (
                <li key={s.label}>
                  <Link to={s.path} className="text-sm text-stone-300 hover:text-amber-400 transition-colors flex items-center gap-2">
                    <i className="ri-arrow-right-s-line text-amber-600"></i>
                    {s.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Col 4 — Localités */}
          <div>
            <h3 className="text-xs uppercase tracking-widest text-stone-400 mb-4">Localités</h3>
            <ul className="space-y-2">
              {localities.map((l) => (
                <li key={l.label}>
                  <Link to={l.path} className="text-sm text-stone-300 hover:text-amber-400 transition-colors flex items-center gap-2">
                    <i className="ri-map-pin-line text-amber-600"></i>
                    {l.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Col 5 — Contact */}
          <div>
            <h3 className="text-xs uppercase tracking-widest text-stone-400 mb-4">Contact</h3>
            <div className="space-y-4">
              <div className="flex items-start gap-3">
                <div className="w-8 h-8 flex items-center justify-center rounded-full bg-stone-800 shrink-0 mt-0.5">
                  <i className="ri-map-pin-2-line text-amber-600 text-sm"></i>
                </div>
                <div>
                  <p className="text-xs text-stone-500 mb-0.5">Adresse</p>
                  <p className="text-sm text-stone-300">Rue de Pramagnon 32, 3979 Grône</p>
                </div>
              </div>
              <div className="flex items-start gap-3">
                <div className="w-8 h-8 flex items-center justify-center rounded-full bg-stone-800 shrink-0 mt-0.5">
                  <i className="ri-phone-line text-amber-600 text-sm"></i>
                </div>
                <div>
                  <p className="text-xs text-stone-500 mb-0.5">Téléphone</p>
                  <a href="tel:+41775117552" className="text-sm text-stone-300 hover:text-amber-400 transition-colors">+41 77 511 75 52</a>
                </div>
              </div>
              <div className="flex items-start gap-3">
                <div className="w-8 h-8 flex items-center justify-center rounded-full bg-stone-800 shrink-0 mt-0.5">
                  <i className="ri-mail-line text-amber-600 text-sm"></i>
                </div>
                <div>
                  <p className="text-xs text-stone-500 mb-0.5">Email</p>
                  <a href="mailto:info@carreaux-bat.ch" className="text-sm text-stone-300 hover:text-amber-400 transition-colors">info@carreaux-bat.ch</a>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom bar */}
        <div className="border-t border-stone-700 pt-6 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-stone-500">
            © 2026 Carreaux-Bat Valais. Tous droits réservés.
          </p>
          <div className="flex items-center gap-4 text-xs text-stone-500">
            <Link to="/privacy" className="hover:text-amber-400 transition-colors">Politique de confidentialité</Link>
            <span className="text-stone-600">·</span>
            <Link to="/sitemap" className="hover:text-amber-400 transition-colors">Plan du site</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}